import Vue from 'vue';

export default {
    async getJackpots(clientId, filter) {
        return (await Vue.http.post(`/api/jackpots/list/${clientId}`, filter)).data;
    },
    async getJackpot(jackpotNumber) {
        return (await Vue.http.get(`/api/jackpots/get/${jackpotNumber}`)).data;
    },
    async createSingleJackpot(jackpot) {
        return (await Vue.http.post('/api/jackpots/create/single', jackpot)).data;
    },
    async createSeriesJackpot(jackpot) {
        return (await Vue.http.post('/api/jackpots/create/series', jackpot)).data;
    },
    async updateJackpot(jackpot) {
        return (await Vue.http.post('/api/jackpots/update', jackpot)).data;
    },
    async getJackpotTemplate(clientId, branch) {
        return (await Vue.http.get(`/api/jackpots/${clientId}/${branch}/template`)).data;
    },
    async pauseJackpot(jackpot) {
        return (await Vue.http.post(`/api/jackpots/pause/${jackpot.number}`)).data;
    },
    async resumeJackpot(jackpot) {
        return (await Vue.http.post(`/api/jackpots/resume/${jackpot.number}`)).data;
    },
    async forbidJackpot(jackpot) {
        return (await Vue.http.post(`/api/jackpots/forbid/${jackpot.number}`)).data;
    },
    calcProgress(jackpot) {
        return (jackpot.state.amountCurrent / jackpot.triggerSettings.amount * 100).toFixed(2);
    }
}



// WEBPACK FOOTER //
// ./src/services/jackpot.service.js